import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { LANGUAGES } from '~/utils/constants/common';
import { LanguageEnum } from '~/utils/enum/base';
import packageJson from '../../package.json';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: LANGUAGES,
    lng: LanguageEnum.EN,
    fallbackLng: LanguageEnum.EN,

    react: { useSuspense: true },
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['path', 'cookie', 'htmlTag'],
      caches: ['cookie'],
    },
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?version=${packageJson.version}`,
    },
  });

export default i18n;
